<template lang="pug">
  .box
    .blockOne
      .oneHeader
        h3 产品概述
        .blue
      .oneBody
        p 一个信息的集成和统一展示环境，是将分散、异构的政务应用系统和信息资源进行聚合，通过统一的访问入口，实现结构化数据资源、非结构化文档和互联网资源、各种应用系统跨数据库、跨系统平台的无缝接入和集成，提供一个支持信息访问、传递、以及协作的集成化环境，实现个性化业务应用的高效开发、集成、部署与管理；并根据每个政企的特点、喜好和角色的不同，提供量身定做专属工作台，以及访问关键业务信息的安全通道和个性化定制，方便其他结构组织门户与陇政钉门户实现无缝完美对接，将不同的应用在同一平台上得到统一管理，打造千人千面的专属门户，实现组织结构各类资源的有效整合和精准推送。
    .blockTwo
      .twoHeader
        h3 产品功能
        .blue
      .twoBody
        .pBox
          h3 1. 门户模板
          p 集标题、幻灯、公告、列表应用、一般应用、横幅广告、信息列表、宫格、分栏组件等就大要素于一体。
          h3 2. 浮动图片
          p 设置主页浮动图片和对应的链接地址。
          h3 3. 导航树
          p 支持所见即所得的方式进行导航树的配置，配置内容可以 输入URL地址、也可以选择系统模块、甚至可以将应用中的导航节点添加到导航树中。
          h3 4. 快捷方式
          p 管理系统主页快捷方式键及其对应的系统链接信息。
          h3 5. APP唤醒
          p 可以将任意APP进行唤醒并且与入门户深度融合。
    .blockThree
      .threeHeader
        h3 产品特点
        .blue
      .threeBody
        ul
          li
            h4 主题风格
            p 管理系统主题风格及所对应的资源目录信息。
          li
            h4 常用资料
            p 根据门户应用的需要可以将系统内容作为门户中常用的链接，方便门户配置时调用，便捷高效提取并运用数据。
          li
            h4 窗口列表
            p 维护系统内数据和外部页面的管理，为页面内容配置提供必要的元素。
          li(style="margin-right:0px;")
            h4 用户识别
            p 用户登录系统时，系统可以在鉴别访问者的用户角色后，自动根据规则和权限设置推送、展示相应的信息和待办工作提醒。
    .blockTwo
      .twoHeader
        h3 定制流程
        .blue
      .twoBody
        .one
          h4 1. 申请开通
          p 约定沟通方式、时间及地点
        <i class="iconfont iconiconset0438"></i>
        .one
          h4 2. 选择模板
          p 双向沟通，提出需求，洽谈细节
        <i class="iconfont iconiconset0438"></i>
        .one
          h4 3. 确定内容
          p 制定开发方案及预算
        <i class="iconfont iconiconset0438"></i>
        .one
          h4 4. 执行定制
          p 签订合同，支付预付款
        <i class="iconfont iconiconset0438"></i>
        .one
          h4 5. 验收交付
          p 验收合格，支付余款
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.commit('changeNavOther', 4)
  }
}
</script>

<style lang="less" scoped>
  .blockTwo{
    padding: 0 15% 30px;
    background-color: #ededed;
    .twoHeader{
      font-size: 20px;
      padding: 30px 0;
      h3{
        font-weight: 400;
        text-align: right;
      }
      .blue{
        float: right;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .twoBody{
      overflow: hidden;
      margin-top: 20px;
      .pBox{
        padding: 20px;
        color: #333;
        h3{
          margin: 10px 0;
        }
        p{
          line-height: 26px;
        }
      }
      .one{
        float: left;
        padding: 10px 20px 20px;
        border: 2px solid #ccc;
        border-radius: 10px;
        margin-bottom: 10px;
        h4{
          margin: 10px 0;
        }
      }
      .iconfont{
        float: left;
        font-size: 72px;
        color: #ccc;
        margin: 0 10px;
      }
    }
  }
  .blockOne{
    width: 70%;
    margin: 0 auto;
    .oneHeader{
      font-size: 20px;
      padding-bottom: 30px;
      h3{
        font-weight: 400;
      }
      .blue{
        float: left;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .oneBody{
      margin-bottom: 20px;
      p{
        padding: 10px 30px;
        text-align: justify;
        text-indent: 2em;
        line-height: 26px;
      }
    }
  }
  .blockThree{
    width: 70%;
    margin: 0 auto;
    .threeHeader{
      font-size: 20px;
      padding: 30px 0;
      h3{
        font-weight: 400;
      }
      .blue{
        float: left;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .threeBody{
      margin-bottom: 30px;
      ul{
        overflow: hidden;
        li{
          float: left;
          margin-right: 18px;
          width: 21%;
          padding: 10px;
          border: 2px solid #ccc;
          border-radius: 10px;
          height: 172px;
          h4{
            margin: 10px 0;
          }
          p{
            line-height: 26px;
            text-align: justify;
          }
        }
      }
    }
  }
</style>
